import type {CustomerAnalysisOptions} from "./CustomerAnalysisOptions.ts";
import type {Setter} from "../../util/setter/Setter.ts";
import {useFieldSetter} from "../../util/setter/FieldSetter.ts";
import {Field} from "@matillion/component-library";
import {SimpleSelect} from "../../components/select/SimpleSelect.tsx";
import {PromiseRunnerOptionsWidget} from "../../analysis-process/2-option-selection/PromiseRunnerOptionsWidget.tsx";

interface Props {
    options: CustomerAnalysisOptions
    setOptions: Setter<CustomerAnalysisOptions>
}
export function CustomerJobStrategyOptions({options, setOptions}: Props) {
    const [jobDownloadStrategy, setJobDownloadStrategy] = useFieldSetter(options, setOptions, "jobDownloadStrategy")
    const [jobDownloadRunner, setJobDownloadRunner] = useFieldSetter(options, setOptions, "jobDownloadRunner")

    return <div>
        <Field
            title="Job Download Strategy"
            description="Whether to download jobs individually, or in bulk using the Export endpoint"
            type="select" value={jobDownloadStrategy}>
            <SimpleSelect value={jobDownloadStrategy}
                          onChange={(value)=>setJobDownloadStrategy(value === "EXPORT" ? "EXPORT" : "INDIVIDUAL")}
                          options={["EXPORT", "INDIVIDUAL"]} />
        </Field>
        <PromiseRunnerOptionsWidget title={"Job Download Runner"}
                                    options={jobDownloadRunner}
                                    setOptions={setJobDownloadRunner}
                                    disabled={jobDownloadStrategy === "EXPORT"}
                                    />
    </div>
}
